import * as React from "react";
import { Text, TextVariant } from "../../ui";

export const PartsMessage: React.FC<{ title: string; body: string }> = ({ title, body }) => (
  <div className="text-center py-10 px-4">
    <Text variant={TextVariant.H6} className="mb-2">
      {title}
    </Text>
    <Text variant={TextVariant.BODY2} className="text-gray-400">
      {body}
    </Text>
  </div>
);
